import { Tooltip, Typography } from '@mui/material';
import React from 'react';

const bubbleSlotProps = {
    tooltip: {
        sx: (theme) => ({
            bgcolor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.common.white,
            color: theme.palette.text.primary,
            maxWidth: 360,
            px: 2,
            py: 1.5,
            boxShadow: theme.shadows[6],
            border: '1px solid',
            borderColor: theme.palette.primary.main,
            borderRadius: 2,
            '& .MuiTooltip-arrow': {
                color: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.common.white,
                '&::before': {
                    border: '1px solid',
                    borderColor: theme.palette.primary.main,
                },
            },
        }),
    },
};

export default function ActionBubbleTooltip({ title, children, placement = 'top', ...props }) {
    return (
        <Tooltip
            arrow
            placement={placement}
            describeChild
            title={(
                <Typography
                    component="span"
                    sx={{
                        display: 'block',
                        fontSize: '0.95rem',
                        lineHeight: 1.55,
                        fontWeight: 500,
                    }}
                >
                    {title}
                </Typography>
            )}
            slotProps={bubbleSlotProps}
            {...props}
        >
            {children}
        </Tooltip>
    );
}
